import { useMutation, useQueryClient } from "@tanstack/react-query";
import { uploadDocuments } from "@/api";

export const useUploadDocuments = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      documentType,
      dealIdStr,
      files
    } : {
      documentType: string
      dealIdStr: string
      files: File[]
    }) => uploadDocuments({ documentType, dealIdStr, files }),
    
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["dropboxDocuments", parseInt(variables.dealIdStr ?? "0")] });
    },
  });
};
